import {makeStyles} from '@material-ui/core/styles'

import {theme} from '../theme'

const padding = theme.spacing(2)

export const useInputClasses = makeStyles(
  {
    root: {
      backgroundColor: theme.palette.grey[300],
      borderRadius: theme.shape.borderRadius,
      lineHeight: theme.typography.body1.lineHeight,
      fontWeight: theme.typography.fontWeightMedium as any,
    },
    input: {
      padding: `${padding + 10}px ${padding}px ${padding - 10}px`,
      height: theme.typography.body1.lineHeight,
      '&:-webkit-autofill': {
        borderRadius: 'inherit',
      },
    },
    error: {
      boxShadow: `0 0 0 2px ${theme.palette.error.main} inset`,
    },
    adornedEnd: {
      paddingRight: padding,
    },
    inputAdornedEnd: {
      paddingRight: 0,
    },
  },
  {name: 'LPCInput'},
)

export const useLabelClasses = makeStyles(
  {
    root: {
      lineHeight: theme.typography.body1.lineHeight,
      '&$focused': {
        color: '#8F8C89',
      },
    },
    filled: {
      transform: `translate(${padding}px, 22px) scale(1)`,
      '&$shrink': {
        transform: `translate(${padding}px, 12px) scale(.75)`,
      },
    },
    focused: {},
    shrink: {},
  },
  {name: 'LPCLabelInput'},
)

export const useHelperClasses = makeStyles(
  {
    root: {
      marginLeft: padding,
      marginRight: padding,
    },
  },
  {name: 'LPCHelperInput'},
)

export const useSelectClasses = makeStyles(
  {
    select: {
      display: 'flex',
      padding,
    },
  },
  {name: 'LPCSelectInput'},
)

export const useMenuListClasses = makeStyles({
  list: {
    padding: 10,
  },
})
